import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { apiGet } from '../../../helpers/apiHelper';
import Spinner from '../../components/Spinner/Spinner';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { categoryUrlSelector, standortUrlSelector } from '../../../modules/selectors/url';
import StandortLink from '../../components/VHost/StandortLink';
import { ExternalLink } from '../../components/form-elements/Link';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';

function CookiePolicy() {
    useEffect(() => {
        try {
            window?.OneTrust?.initializeCookiePolicyHtml?.();
        } catch (e) {
            console.error('Error while initializing cookie list:', e);
        }
    }, []);

    return <div id="ot-sdk-cookie-policy" />;
}

class Footerpages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            seitenTexte: null,
            loading: true,
        };
    }

    goBack() {
        window.history.back();
    }

    componentDidMount() {
        apiGet('/api/v1/SeitenTexte', { standortUrl: this.props.standortUrl }, (error, data) => {
            if (error) console.error(error);
            else if (!data.success) console.error(data);
            else this.setState({ seitenTexte: data.body });
        });
        this.setState({ loading: false }); 
    }
    
    render() {
        const { markenStandort, categoryUrl } = this.props;
        const { seitenTexte, loading } = this.state;
        const getBreadCrumbLabel = () => {
         switch (categoryUrl) {
            case 'lieferUndVersand':
                return 'Lieferung und Versand';
            case 'erklaerungZurBarrierefreiheit':
                return 'Erklärung zur Barrierefreiheit';    
            case 'entsorgung':
                return 'Entsorgung';    
            default:
                return categoryUrl;
        }
    }

        let batterieText = seitenTexte && seitenTexte.find(text => text.name.toLowerCase() === "batterie");
        let altölText = seitenTexte && seitenTexte.find(text => text.name.toLowerCase() === "altöl");
        // eslint-disable-next-line prefer-template
        let entsorgungText = batterieText?.text + "</br>" + altölText?.text;

        return (
            <>
                {!this.props?.withoutBreadCrumbs &&
                <BreadCrumbSelector
                    additionalCrumbs={[{ label: getBreadCrumbLabel() }]}
                />}
                {!loading ? (
                    <div>
                        {seitenTexte && categoryUrl ? (
                            <div style={{ margin: '0 10px', paddingTop: 15 }}>
                                {categoryUrl === 'lieferUndVersand' ? (
                                    // TODO: use <Button/>
                                    <div className="versand_container">
                                        <button className="versand_button" onClick={this.goBack}>ZURÜCK</button>
                                    </div>
                                ) : null}
                                {categoryUrl === 'versandkosten' ? (
                                    // TODO: use <Button/>
                                    <div className="versand_container">
                                        <button className="versand_button" onClick={this.goBack}>ZURÜCK</button>
                                    </div>
                                ) : null}
                                {categoryUrl === 'entsorgung' ? (
                                    // TODO: use <Button/>
                                    <div className="versand_container">
                                        <button className="versand_button" onClick={this.goBack}>ZURÜCK</button>
                                    </div>
                                ) : null}
                                {categoryUrl === 'erklaerungZurBarrierefreiheit' ? (
                                    // TODO: use <Button/>
                                    <div className="versand_container">
                                        <button className="versand_button" onClick={this.goBack}>ZURÜCK</button>
                                    </div>
                                ) : null}
                                {seitenTexte.map(text => (
                                    <div key={text._id}>
                                        {text.name.toLowerCase() === categoryUrl ? (
                                            <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: text.text }} />
                                        ) : null}
                                        {categoryUrl === 'lieferUndVersand' ? (
                                            <div>
                                                {text.name.toLowerCase() === 'versandkosten' ? (
                                                    <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: text.text }} />
                                                ) : null}
                                                {text.name.toLowerCase() === 'bezahlung' ? (
                                                    <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: text.text }} />
                                                ) : null}
                                            </div>
                                        ) : null}
                                        {categoryUrl === 'erklaerungZurBarrierefreiheit' ? (
                                            <div>
                                                {text.name.toLowerCase() === 'barrierefreiheit' ? (
                                                    <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: text.text }} />
                                                ) : null}
                                            </div>
                                        ) : null}
                                    </div>
                                ))}
                                {/*2 Zusatz text für LieferUndVersand Seite*/}
                                {categoryUrl === 'lieferUndVersand' ? (
                                    <div className="versandkosten_content">
                                        <div>
                                            <h2>
                                                <strong>Hinweis zur Batterieentsorgung</strong>
                                            </h2>
                                            Da Warensendungen Batterien und Akkus enthalten können, weisen wir nach dem Batteriegesetz auf
                                            folgendes hin: Batterien und Akkus dürfen nicht im Hausmüll entsorgt werden. Sie sind zur
                                            Rückgabe gebrauchter Batterien und Akkus verpflichtet. Altbatterien können u. a. Schadstoffe
                                            enthalten, die bei einer nicht sachgemäßen Lagerung oder Entsorgung die Umwelt oder Ihre
                                            Gesundheit schädigen können. Batterien enthalten u. a. auch wichtige Rohstoffe (Eisen, Zink,
                                            Mangan, Nickel) und können verwertet werden. Sie haben die Möglichkeit, die Batterien nach
                                            Gebrauch entweder an uns zurückzusenden oder in Ihrer unmittelbaren Nähe (z. B. im Handel oder
                                            in kommunalen Sammelstellen oder in unserem Versandlager) unentgeltlich zurückzugeben. Die
                                            Rückgabe in Verkaufsstellen ist dabei für Endnutzer auf die übliche Menge sowie Altbatterien
                                            beschränkt, die der Vertreiber als Neubatterien in seinem Sortiment führt oder geführt hat.
                                            <br />
                                            Das Zeichen mit der durchkreuzten Mülltonne bedeutet, dass Sie Batterien und Akkus nicht im
                                            Hausmüll entsorgen dürfen. Unter diesem Verzeichnis finden Sie zusätzlich nachstehende Symbole
                                            mit folgender Bedeutung:
                                            <br />
                                            <ul>
                                                <li>Pb: Batterie enthält Blei</li>
                                                <li>Cd: Batterie enthält Cadmium</li>
                                                <li>Hg: Batterie enthält Quecksilber</li>
                                            </ul>
                                            <p />
                                            <h2>
                                                <strong>Hinweis zur Entsorgung von Altöl</strong>
                                            </h2>
                                            <p>
                                                {' '}
                                                Wir sind aufgrund der Altölverordnung bei Abgabe von Verbrennungsmotorenöl und/oder
                                                Getriebeöl verpflichtet, solches gebrauchtes Öl sowie Ölfilter und die beim Ölwechsel
                                                regelmäßig anfallenden ölhaltigen Abfälle (im Folgenden „Altöl“) zurückzunehmen. Sofern Sie
                                                als gewerbliches oder sonstiges wirtschaftliches Unternehmen oder öffentliche Einrichtungen
                                                Verbrennungsmotoren- oder Getriebeöle erwerben, weisen wir darauf hin, dass wir Ihnen
                                                gegenüber zur Erfüllung unserer Annahmepflichten Dritte einsetzen können. Die Menge des
                                                Altöls, die Sie bei uns zurückgeben können, ist auf das im Einzelfall an Sie abgegebene
                                                Verbrennungsmotoren- und/oder Getriebeöl begrenzt. Der Ort für die Rückgabe ist: <br />
                                                <strong>
                                                    {`${markenStandort.anschrift.firma} | ${markenStandort.anschrift.strasse} | ${markenStandort.anschrift.plz} ${markenStandort.anschrift.ort}`}
                                                </strong>{' '}
                                                <br />
                                                Sie können das Altöl dort jederzeit kostenlos während unserer Öffnungszeiten ({' '}
                                                <strong>{markenStandort.oeffnungszeiten}</strong> ) abgeben. Es besteht auch die
                                                Möglichkeit, das Altöl an uns zurückzusenden. Bitte beachten Sie, dass für das Versenden
                                                besondere Transportbedingungen, insbesondere die Bestimmungen zum Gefahrgut gelten können;
                                                bitte holen Sie vor der Versendung entsprechende Informationen ein. Nehmen Sie auch zur
                                                Kenntnis, dass wir die Kosten der Rücksendung von Altöl nicht übernehmen. Unsere
                                                Annahmestelle verfügt über eine Einrichtung, die es ermöglicht, den Ölwechsel fachgerecht
                                                durchzuführen.
                                            </p>
                                        </div>
                                    </div>
                                ) : null}
                                {/*Zusatz Text für Impressum wird nicht aus DB geladen */}
                                {categoryUrl === 'impressum' ? (
                                    <div>
                                        <div className="impressum_content">
                                            <p>
                                                <b>Bildnachweise</b>
                                                <br />
                                                fotolia.com, istockphoto.com, colourbox.de, 123rf.com, caiaimages, westend61.de,
                                                imagesource.com, thinkstockphotos.de, shutterstock.com
                                                <br />
                                                <br />
                                                Illustrationen: ymnky.de
                                                <br />
                                                <br />
                                                TECHNO-EINKAUF GmbH <br />
                                                K. Heidersberger, <br />
                                                Martin Foddanu Photography,
                                                <ExternalLink to="https://www.martin-foddanu.de">www.martin-foddanu.de</ExternalLink>
                                                <br />
                                                Oberland Mangold GmbH <br />
                                                <br />
                                                <StandortLink to="/copyright" style={{ color: 'black' }}>
                                                    <b>Einzelbildnachweise: Für weitere Informationen bitte hier klicken &gt;&gt;</b>
                                                </StandortLink>
                                            </p>
                                        </div>
                                    </div>
                                ) : null}
                                {/* {categoryUrl === 'gutscheine' ? (
                                    <div className='uk-margin-auto uk-padding-small'>
                                        <h3>Gutscheine</h3>
                                        <p>Unsere Aktionsgutscheine erhalten Sie im Rahmen unserer Werbeaktionen. Das erfolgt beispielsweise per E-Mail, Banner oder in Form eines Coupons. Unsere Aktionsgutscheine können Sie nur im Rahmen unseres Online-Shops einlösen und nicht in unseren Filialen.</p>
                                        <h5>Wie löse ich einen Aktionsgutschein ein?</h5>
                                        <p>Klicken Sie auf den Gutschein im Onlineshop. Es öffnet sich ein Fenster, in dem Sie den Rabattcode sowie alle Informationen zu dieser Gutscheinaktion finden. Klicken Sie dann auf den Rabattcode um ihn zu kopieren. Nachdem Sie Artikel in den Warenkorb gelegt haben, können Sie den Rabattcode direkt im Warenkorb einlösen:</p>
                                        <ul>
                                            <li>Gehen Sie zum <span className="uk-text-bold">Warenkorb</span>.</li>
                                            <li>Geben Sie den Code in das <span className="uk-text-bold">Feld „Gutscheincode“</span> (unterhalb der Gesamtsumme) ein.</li>
                                            <li>Lösen Sie den Rabatt mit Klick auf den <span className="uk-text-bold">Button „Einlösen“</span> ein.</li>
                                            <li>Der Rabatt wird Ihnen sofort angerechnet und mit der <span className="uk-text-bold">Ersparnis angezeigt</span>.</li>
                                            <li>Nach Auswahl der Zahlungsmethode wird der Rabatt noch einmal separat in Ihrer <span className="uk-text-bold">Bestellübersicht</span> ausgewiesen.</li>
                                        </ul>
                                        <h5>Kann ich alle Artikel mit einem Aktionsgutschein bezahlen?</h5>
                                        <p>Die Gültigkeit unserer Aktionsgutscheine kann auf bestimmte Produkte, Hersteller, Marken oder Sortimentsbereiche beschränkt sein. Ein Aktionsgutschein kann nicht mit einer anderen Aktion kombiniert werden. Aktionsgutscheine werden nur auf den Warenwert und nicht auf Versandkosten oder sonstige Zuschläge angerechnet.</p>
                                        <h5>Kann ich mehrere Aktionsgutscheine in einer Bestellung anwenden?</h5>
                                        <p>Pro Bestellung darf nur ein Aktionsgutschein eingelöst werden.</p>
                                        <h5>Kann ich mir den Aktionsgutschein in bar auszahlen lassen?</h5>
                                        <p>Aktionsgutscheine werden nicht in bar ausgezahlt.</p>
                                        <h5>Was passiert mit meinem Restguthaben?</h5>
                                        <p>Es besteht kein Anspruch auf Anrechnung eines Restguthabens. Mit dem Einlösen des Rabattcodes verfällt der Gutscheincode.</p>
                                        <h5>Kann ich nachträglich einen Aktionsgutschein mit einer Bestellung verrechnen?</h5>
                                        <p>Nach Ablauf des Gültigkeitszeitraumes oder nach Bestellabschluss kann eine Einlösung der Gutscheine nicht mehr stattfinden. Das ergibt sich auch aus der jeweiligen Gutscheinaktion.</p>
                                        <h5>Was passiert mit meinem Gutscheinrabatt, wenn ich die Bestellung zurückgeschickt habe?</h5>
                                        <p>Der Aktionsgutschein wird nicht erstattet, wenn die Ware ganz oder teilweise retourniert wird, sofern der Aktionsgutschein im Rahmen einer Werbeaktion ausgegeben wurde und dafür keine Gegenleistung erbracht wurde. Gilt für den Aktionsgutschein ein Mindesteinkaufspreis, versteht sich dieser nach Abzug etwaiger (Teil-) Waren-Retouren. Wird der Mindesteinkaufspreis nach (Teil-) Waren-Retouren unterschritten, berechnen wir den ursprünglichen vollen Preis der Waren, die Sie behalten.</p><h5>Warum wird mein Rabattcode nicht akzeptiert?</h5><p>Das kann einen der folgenden Gründe haben:</p><ul><li>Der Aktionsgutschein ist bereits abgelaufen. Ein Rabattcode gilt nur während des angegebenen Aktionszeitraumes. Ein späteres Einlösen ist leider nicht möglich. </li>
                                            <li>Einige Gutscheincodes sind nur für bestimmte Artikel oder Produktkategorien gültig. </li>
                                            <li>Eventuell wurde der angegebene Mindestbestellwert nicht erreicht.</li>
                                            <li>Überprüfen Sie bitte auch die richtige Eingabe des Gutscheincodes.</li>
                                        </ul>
                                    </div>
                                ) : null} */}
                                {/*Zusatzt Text für Copyright wird nicht dynamisch geladen */}
                                {/* {categoryUrl === 'copyright' ? (
                                    <div className="bezahlung_content">
                                        <p>
                                        <b>Bildnachweise</b>
                                                <br />
                                                fotolia.com, istockphoto.com, colourbox.de, 123rf.com, caiaimages, westend61.de,
                                                imagesource.com, thinkstockphotos.de, shutterstock.com
                                                <br />
                                                <br />
                                                Illustrationen: ymnky.de
                                                <br />
                                                <br />
                                                TECHNO-EINKAUF GmbH <br />
                                                K. Heidersberger, <br />
                                                Martin Foddanu Photography,
                                                <ExternalLink to="https://www.martin-foddanu.de">www.martin-foddanu.de</ExternalLink>
                                                <br />
                                                Oberland Mangold GmbH <br />
                                                <br />
                                                <StandortLink to="/copyright" style={{ color: 'black' }}>
                                                    <b>Einzelbildnachweise: Für weitere Informationen bitte hier klicken &gt;&gt;</b>
                                                </StandortLink>
                                            </p>
                                        </div>
                                ) : null} */}
                                {/*Zusatzt Text für Copyright wird nicht dynamisch geladen */}
                                {/*categoryUrl === 'copyright' ? (
                                    <div className="bezahlung_content">
                                        <p>
                                            <b>Powered by <ExternalLink to="https://technoeinkauf.de/">TECHNO-EINKAUF GmbH</ExternalLink></b>
                                            <br />
                                            <b>Bildhinweise</b>
                                            <br />
                                            <br />
                                            123RF
                                            <br />
                                            <ExternalLink to="https://123rf.de/">
                                                https://123rf.de/
                                            </ExternalLink>
                                            <br />
                                            <br />
                                            BildNr.: 87859800/progressman/123rf<br />
                                            BildNr.: 58897689/cheskyw/123rf<br />
                                            BildNr.: 34199667/kostsov/123rf<br />
                                            BildNr.: 14275764/Eric Isselee/123rf<br />
                                            <br />
                                            <br />
                                            Adobe Stock
                                            <br />
                                            <ExternalLink to="https://stock.adobe.com/de/">
                                                https://stock.adobe.com/de/
                                            </ExternalLink>
                                            <br />
                                            <br />
                                            BildNr.: 91944450_1/fotohansel/Adobe Stock<br />
                                            BildNr.: 377079233/iaremenko/Adobe Stock<br />
                                            BildNr.: 348881518/Image Factory/ Adobe Stock<br />
                                            BildNr.: 309895310/tadeas/Adobe Stock<br />
                                            BildNr.: 275331757/Сергей Старостов/Adobe Stock<br />
                                            BildNr.: 233013170/fotomek/Adobe Stock<br />
                                            BildNr.: 231406271/Soloviova Liudmyla/Adobe Stock<br />
                                            BildNr.: 226750797/Moose/Adobe Stock<br />
                                            BildNr.: 216405803/eyetronic/Adobe Stock<br />
                                            BildNr.: 201906164/powell83/Adobe Stock<br />
                                            BildNr.: 191203158/Soloviova Liudmyla/Adobe Stock<br />
                                            BildNr.: 188486499/cppzone/Adobe Stock<br />
                                            BildNr.: 144452278/Kavalenkava/Adobe Stock<br />
                                            BildNr.: 144355479/carol_anne/Adobe Stock<br />
                                            BildNr.: 144235019/Dezay/Adobe Stock<br />
                                            BildNr.: 142892109/elektronik-zeit/Adobe Stock<br />
                                            BildNr.: 140912796/Jana Schönknecht/Adobe Stock<br />
                                            BildNr.: 138757325/bernardbodo/Adobe Stock<br />
                                            BildNr.: 135758236/Manuel Schönfeld/Adobe Stock<br />
                                            BildNr.: 133310612/Barselona Dreams/Adobe Stock<br />
                                            BildNr.: 122524257/ magicbeam/Adobe Stock<br />
                                            BildNr.: 109893606/Stockwerk-Fotodesign/Adobe Stock<br />
                                            BildNr.: 107877288/Kadmy/Adobe Stock<br />
                                            BildNr.: 98236136/juliamehl/Adobe Stock<br />
                                            BildNr.: 87060108/industrieblick/Adobe Stock<br />
                                            BildNr.: 81873418/industrieblick/Adobe Stock<br />
                                            BildNr.: 80538482/BillionPhotos.com/Adobe Stock<br />
                                            BildNr.: 80060421/amstockphoto/Adobe Stock<br />
                                            BildNr.: 79382138/mariusika11/Adobe Stock<br />
                                            BildNr.: 66634635/lukatme1/Adobe Stock<br />
                                            BildNr.: 66389326/mikemobil2014/Adobe Stock<br />
                                            BildNr.: 65991331/luckybusiness/Adobe Stock<br />
                                            BildNr.: 64487421/bizoo_n/Adobe Stock<br />
                                            BildNr.: 62053263/sima/Adobe Stock<br />
                                            BildNr.: 58618295/CPN/Adobe Stock<br />
                                            BildNr.: 55328545/Karin & Uwe Annas/Adobe Stock<br />
                                            BildNr.: 55317457/Karin & Uwe Annas/Adobe Stock<br />
                                            BildNr.: 55293291/NorGal/Adobe Stock<br />
                                            BildNr.: 55172937/Photocreo Bednarek/Adobe Stock<br />
                                            BildNr.: 52209425/Stephanie Eichler/Adobe Stock<br />
                                            BildNr.: 40132948/Karin & Uwe Annas/Adobe Stock<br />
                                            BildNr.: 39889047/Karin & Uwe Annas/Adobe Stock<br />
                                            BildNr.: 35117979/Horst Schmidt/Adobe Stock<br />
                                            BildNr.: 121990360/chesky/fotolia<br />
                                            BildNr.: 121990359/chesky/fotolia<br />
                                            BildNr.: 121990326/chesky/fotolia<br />
                                            BildNr.: 116049634/chesky/fotolia<br />
                                            BildNr.: 107113390/chombosan/fotolia<br />
                                            BildNr.: 97876318/johnnypicture/fotolia<br />
                                            BildNr.: 97398707/industrieblick/fotolia<br />
                                            BildNr.: 97394544/gargantiopa/fotolia<br />
                                            BildNr.: 95773682/NorGal/fotolia<br />
                                            BildNr.: 93624881/Syda Productions/fotolia<br />
                                            BildNr.: 93022711/manhattantester/fotolia<br />
                                            BildNr.: 90430990/alexdemeshko/fotolia<br />
                                            BildNr.: 89772700/trodler1/fotolia<br />
                                            BildNr.: 89444757/lassedesignen/fotolia<br />
                                            BildNr.: 88682270/and.one/fotolia<br />
                                            BildNr.: 88127226/Syda Productions/fotolia<br />
                                            BildNr.: 87972266/DR/fotolia<br />
                                            BildNr.: 85458115/janimal/fotolia<br />
                                            BildNr.: 83803874/highwaystarz/fotolia<br />
                                            BildNr.: 82155794/icsnaps/fotolia<br />
                                            BildNr.: 81233185/atomicrooster/fotolia<br />
                                            BildNr.: 78816752/dmindphoto/fotolia<br />
                                            BildNr.: 78750895/Africa Studio/fotolia<br />
                                            BildNr.: 78485732/RAM/fotolia<br />
                                            BildNr.: 77017022/antonmatveev/fotolia<br />
                                            BildNr.: 76190500/Nejron Photo/fotolia<br />
                                            BildNr.: 75800482/Nejron Photo/fotolia<br />
                                            BildNr.: 72198086/Vlad Kochelaevskiy/fotolia<br />
                                            BildNr.: 68749853/Nikolai Sorokin/fotolia<br />
                                            BildNr.: 68109070/netkrawlr/fotolia<br />
                                            BildNr.: 67967866/magdal3na/fotolia<br />
                                            BildNr.: 57963355/bonzodog/fotolia<br />
                                            BildNr.: 57958724/zerbor/fotolia<br />
                                            BildNr.: 36851107/Vlad Kochelaevskiy/fotolia<br />
                                            BildNr.: 35380509/S.Z./fotolia<br />
                                            BildNr.: 20104451/klickerminth/fotolia<br />
                                            BildNr.: 19003531/Foxy_A/fotolia<br />
                                            BildNr.: 9357803/Timur Anikin/fotolia<br />
                                            <br />
                                            <br />
                                            gettyimages
                                            <br />
                                            <ExternalLink to="https://www.gettyimages.de/">
                                                https://www.gettyimages.de/
                                            </ExternalLink>
                                            <br />
                                            <br />
                                            BildNr.: 412-15839/Sam Edwards/caiaimage<br />
                                            BildNr.: 412-15663/Paul Bradbury/caiaimage<br />
                                            BildNr.: 531502717/dolgachov/Getty Images / istock<br />
                                            BildNr.: IS098Y6YZ/Legacy Signature Collection/Image Source<br />
                                            <br />
                                            <br />
                                            Colourbox
                                            <br />
                                            <ExternalLink to="https://www.colourbox.de/">
                                                https://www.colourbox.de/
                                            </ExternalLink>
                                            <br />
                                            <br />
                                            BildNr.: 3675712_1/Maksim Toome/colourbox<br />
                                            BildNr.: 29305983/#246329/colourbox<br />
                                            BildNr.: 13779623/#221789/colourbox<br />
                                            BildNr.: 9684681/tusumaru/colourbox<br />
                                            BildNr.: 8305843/Tomasz Zajda Virrage Images Inc/colourbox<br />
                                            BildNr.: 8227756/#2111/colourbox<br />
                                            BildNr.: 5113066/#1014/colourbox<br />
                                            BildNr.: 4913203/Sergioua/colourbox<br />
                                            BildNr.: 4196719/#7104/colourbox<br />
                                            BildNr.: 3912206/#1014/colourbox<br />
                                            BildNr.: 2901138/#1914/colourbox<br />
                                            BildNr.: 1701601/#1014/colourbox<br />
                                            BildNr.: 1697327/PhotoAlto sas/colourbox<br />
                                            BildNr.: 1507908/ PhotoAlto sas/colourbox<br />
                                            <br />
                                            <br />
                                            iStock
                                            <br />
                                            <ExternalLink to="https://www.istockphoto.com/de">
                                                https://www.istockphoto.com/de
                                            </ExternalLink>
                                            <br />
                                            <br />
                                            BildNr.: 481869644/HarryHuber/istock<br />
                                            BildNr.: 38270530/sestovic/istock<br />
                                            BildNr.: 16719668/deepblue4you/istock<br />
                                            BildNr.: 670201678/Chesky_W/istock Essentials<br />
                                            BildNr.: 636194274/ gutmilos/ istock Essentials<br />
                                            BildNr.: 623865086/ gretanrk/ istock Essentials<br />
                                            BildNr.: 598711334/kostsov/ istock Essentials<br />
                                            BildNr.: 475667353/Bogdanhoda/istock Essentials<br />
                                            BildNr.: 467711984/kadmy/istock Essentials<br />
                                            BildNr.: 176988519/kreinick/ istock Essentials<br />
                                            BildNr.: 148231359/SQUAMISH/istock Essentials<br />
                                            BildNr.: 86895199/gargantiopa/istock Essentials<br />
                                            BildNr.: 79267183/Believe_In_Me/istock Essentials<br />
                                            BildNr.: 72061681/hkeita/istock Essentials<br />
                                            BildNr.: 65621503/Imran Khan/istock Essentials<br />
                                            BildNr.: 55151174/dolgachov/istock Essentials<br />
                                            BildNr.: 54669710/Grassetto/istock Essentials<br />
                                            BildNr.: 48284570/Mikko Lemola/istock Essentials<br />
                                            BildNr.: 41459290/papa1266/istock Essentials<br />
                                            BildNr.: 31851922/deeepblue/istock Essentials<br />
                                            BildNr.: 16666092/vetkit/istock Essentials<br />
                                            BildNr.: 888512024/Onfokus/istock Essentials<br />
                                            BildNr.: 683218266/Wicki58/istock Essentials<br />
                                            BildNr.: 637076516/Hayri Er/istock Essentials<br />
                                            BildNr.: 540194760/mf-guddyx/istock Essentials<br />
                                            BildNr.: 510689315/fstop123/istock Essentials<br />
                                            BildNr.: 510635492/marcduf/istock Essentials<br />
                                            BildNr.: 496979126/ aleksle/istock Essentials<br />
                                            BildNr.: 480905111/Devrimb/istock Essentials<br />
                                            BildNr.: 155276460/deepblue4you/istock Essentials<br />
                                            BildNr.: 155097294/jonmullen/istock Essentials<br />
                                            BildNr.: 155096906/ollo/istock Essentials<br />
                                            BildNr.: 147461111/mevans/istock Essentials<br />
                                            BildNr.: 19794941/4X-image/istock Essentials<br />
                                            BildNr.: 19149083/Floortje/istock Essentials<br />
                                            BildNr.: 15322787/photoggin/istock Essentials<br />
                                            BildNr.: 14872386/Janine Lamontagne/istock Essentials<br />
                                            BildNr.: 14377063/flubydust/istock Essentials<br />
                                            BildNr.: 2651504/kenneth-cheung/istock Essentials<br />
                                            BildNr.: 325744682/Natan86/istock Essentials<br />
                                            BildNr.: 66245596/kokandr/istock Essentials<br />
                                            BildNr.: 452974203/bitontawan/Thinkstock istock<br />
                                            BildNr.: 121915399/iSci/Thinkstock istock/Thinkstock istock<br />
                                            <br />
                                            <br />
                                            Shutterstock
                                            <br />
                                            <ExternalLink to="https://www.shutterstock.com/de/">
                                                https://www.shutterstock.com/de/
                                            </ExternalLink>
                                            <br />
                                            <br />
                                            BildNr.: 325744682/Natan86/shutterstock<br />
                                            BildNr.: 66245596/kokandr/shutterstock<br />
                                            <br />
                                            <br />
                                            Westend61
                                            <br />
                                            <ExternalLink to="https://www.westend61.de/">
                                                https://www.westend61.de/
                                            </ExternalLink>
                                            <br />
                                            <br />
                                            BildNr.: ZEF006906/zerocreatives/westend61<br />
                                            BildNr.: ZEF002065/zerocreatives/westend61<br />
                                            BildNr.: MFF000887/Mareen Fischinger/westend61<br />
                                            BildNr.: LOF001785/Milton Brown/westend61<br />
                                            <br />
                                            <br />
                                            Dreamstime
                                            <br />
                                            <ExternalLink to="https://de.dreamstime.com/">
                                                https://de.dreamstime.com/
                                            </ExternalLink>
                                            <br />
                                            <br />
                                            BildNr.: 49665285/Alexandr Kornienko/Dreamstime<br />
                                            <br />
                                            <br />
                                            TECHNO
                                            <br />
                                            K. Heidersberger, Martin Foddanu
                                            <br />
                                            <br />
                                            Illustrationen
                                            <br />
                                            <ExternalLink to="https://ymnky.de/">ymnky</ExternalLink>
                                        </p>
                                    </div>
                                ) : null*/}
                                {/*text bei altölundbatterie*/}
                                {categoryUrl === 'entsorgung' ? (
                                    <div>
                                        <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: entsorgungText}} />                                    
                                        <div>
                                            <div style={{ textAlign: 'justify' }}>   
                                                <p>                                               
                                                    <strong>                                                   
                                                        {`${markenStandort.anschrift.firma} | ${markenStandort.anschrift.strasse} | ${markenStandort.anschrift.plz} ${markenStandort.anschrift.ort}`}
                                                    </strong>{' '}
                                                    <br />
                                                    <br />
                                                    Sie können das Altöl dort jederzeit kostenlos während unserer Öffnungszeiten: <br />
                                                    <br /> <strong>{markenStandort.oeffnungszeiten}</strong> abgeben. <br /> <br />
                                                    Es besteht auch die Möglichkeit, das Altöl an uns zurückzusenden. Bitte beachten Sie, 
                                                    dass für das Versenden besondere Transportbedingungen, insbesondere die Bestimmungen zum 
                                                    Gefahrgut gelten können; bitte holen Sie vor der Versendung entsprechende Informationen ein. 
                                                    Nehmen Sie auch zur Kenntnis, dass wir die Kosten der Rücksendung von Altöl nicht übernehmen. 
                                                    Unsere Annahmestelle verfügt über eine Einrichtung, die es ermöglicht, den Ölwechsel fachgerecht durchzuführen.
                                                </p>
                                            </div>
                                        </div>
                                    </div>                                            
                                ) : null}
                                {categoryUrl === 'datenschutz' && <CookiePolicy />}
                            </div>
                        ) : null}
                    </div>
                ) : (
                    <div>
                        <Spinner />
                    </div>
                )}
            </>
        );
    }
}

const mapStateToProps = state => ({
    markenStandort: markenStandortSelector(state),
    standortUrl: standortUrlSelector(state),
    categoryUrl: categoryUrlSelector(state),
});

export default connect(mapStateToProps)(Footerpages);
